class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener(
      "mouseenter",
      this.onToggle.bind(this),
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");

    this.addEventListener("mouseenter", this.onToggle.bind(this));
    this.addEventListener("mouseleave", this.close.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
      this.content.classList.remove("submenu-closing");
    }

    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  close() {
    this.content.classList.add("submenu-closing");
    const duration =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--duration-default",
        ),
      ) || 0.2;
    this._closeTimeout = setTimeout(() => {
      this.content.classList.remove("submenu-closing");
      super.close();
      this._closeTimeout = null;
    }, duration * 1000);
  }
}

customElements.define("header-menu", HeaderMenu);

class SubMenuDisclosure extends DetailsDisclosure {
  constructor() {
    super();
    this.addEventListener("mouseenter", this.onToggle.bind(this));
    this.addEventListener("mouseleave", this.close.bind(this));
  }

  onToggle() {
    const siblings = this.closest("ul")?.querySelectorAll("sub-menu-disclosure");
    siblings?.forEach((sibling) => {
      if (sibling !== this) sibling.close();
    });

    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
  }
}

customElements.define("sub-menu-disclosure", SubMenuDisclosure);
